import React from 'react';
import {imagePath} from "../utils/imageUtils";
import ThemableSvgIcon from "./theme/ThemableSvgIcon";

function GalleryToggleButton(props) {
    return (
        <div className="absolute bottom-0 right-0">
            {props.toggleExp360Gallery &&
            <button className="mr-4 p-3 bg-primary-light cursor-pointer print-hidden"
                    onClick={props.toggleExp360Gallery}>
                <img className="w-6 h-6" src={imagePath('360play.svg')} alt="open video"/>
            </button>
            }

            {props.toggleGallery &&
            <button className="p-3 bg-primary-light cursor-pointer print-hidden"
                    onClick={props.toggleGallery}>
                <ThemableSvgIcon name="camera" className="w-6 h-6 text-white" alt="open gallery"/>
            </button>
            }
        </div>
    );
}

export default GalleryToggleButton;